import { ProductSearchListItemProps } from "./ProductSearchListItem";
import TrendingSection from "./TrendingSection";
import LearnerFavoritesSection from "./LearnerFavoritesSection";

type CategoryLink = {
  label: string;
  url: string;
};

type DefaultStateProps = {
  featuredItems: ProductSearchListItemProps[];
  featuredCategories?: CategoryLink[];
  trendingSectionHeader?: string;
  mobileCategoryLimit?: number;
  learnerFavoritesSectionHeader?: string;
  location?: string;
};

const DefaultState = ({
  featuredItems,
  featuredCategories = [],
  trendingSectionHeader,
  mobileCategoryLimit,
  learnerFavoritesSectionHeader,
  location = "embedded-search",
}: DefaultStateProps) => {
  return (
    <div className="w-full flex flex-col gap-4">
      {featuredCategories.length > 0 && (
        <TrendingSection
          categories={featuredCategories}
          sectionHeader={trendingSectionHeader}
          mobileCategoryLimit={mobileCategoryLimit}
          location={location}
        />
      )}
      <LearnerFavoritesSection
        items={featuredItems}
        sectionHeader={learnerFavoritesSectionHeader}
        location={location}
      />
    </div>
  );
};

export default DefaultState;
